import {TASK_ID} from '@shared/data/task-type-data';

export enum ScheduleType {
  Interval = 'Interval',
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
  Yearly = 'Yearly',
  Once = 'Once'
}

export enum ScheduleInterval {
  Seconds = 'Seconds',
  Minutes = 'Minutes',
  Hours = 'Hours',
  Days = 'Days'
}

export enum ParametrsJsonSchemaFieldsType {
  InputText = 0,
  InputNumber = 1,
  InputString = 2,
  InputDate = 3,
  InputTime = 4,
  Select = 5,
  ComboBox = 6
}

export interface LocalizationString {
  [key: string]: string;
}

export interface ParametrsJsonSchemaFieldss {
  FieldName: string;
  FieldLabels: LocalizationString;
  DefaultValue?: any;
  FieldsType: ParametrsJsonSchemaFieldsType;
  PosibleValues?: { [key: string]: string };
}

export interface PosibleExecuteTypes {
  names: LocalizationString;
  executeTypeName: string;
  taskType: TASK_ID;
  groupName: string;
  parametrsJsonSchema: ParametrsJsonSchemaFieldss[];
}

export interface TaskOptionJson {
  ScheduleType?: ScheduleType;
  ScheduleInterval?: ScheduleInterval;
  IntervalValue?: number;
  LaunchTime?: string;
  DaysOfWeek?: number[];
  DaysOfMonth?: number[];
  Months?: number[];
  TimeZone?: string;
  StartDelaySeconds?: number;
  GroupName?: string;
}

export interface BackgroundTask {
  executeTypeName: string;
  isActive: boolean;
  maxExecutions: number;
  isRetryable: boolean;
  maxRetryCount: number;
  taskOptionJson: string;
  parametrsJson: string;
}
